/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkLog } from '../../models/work-log';

export interface WorkLogsControllerFindOne$Params {
  id: string;
}

export function workLogsControllerFindOne(http: HttpClient, rootUrl: string, params: WorkLogsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkLog>> {
  const rb = new RequestBuilder(rootUrl, workLogsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkLog>;
    })
  );
}

workLogsControllerFindOne.PATH = '/work-logs/{id}';
